export const appCourseTeaser = {
  create: function () {
    var that = this;
    if ($('.js-course-teaser').length) {
      $('.js-course-teaser-slider').each(function (index) {
        var main = $(this).parents().eq(2),
          prevButton = $(main).find('.js-course-teaser-prev'),
          nextButton = $(main).find('.js-course-teaser-next');
        //console.log('<: ', prevButton);
        //console.log('>: ', nextButton);
        $(this).attr('data-ndx', index);
        $(prevButton).attr('data-ndx', index);
        $(nextButton).attr('data-ndx', index);
      });
      setTimeout(function () {
        that.initCourseTeaserSliders();
      }, 50);
      that.bindEvents();
    }
    // solve the issue of focus within for touchscreens
    this.addFocusWithinHandling();
  },
  bindEvents: function () {
    var that = this;
    $(document).on('click', '.js-tab', function () {
      var tab = $(this),
        tabBlock = $(tab).closest('.js-tabs-main'),
        tabPanelID = $(tab).attr('aria-controls'),
        tabPanel = $(tabBlock).find('.js-tab-panel#' + tabPanelID);
      $(tabBlock).find('.js-tab').attr('aria-expanded', 'false');
      $(tabBlock).find('.js-tabs li').removeClass('active');
      $(tabBlock).find('.js-tab-panel').attr('aria-hidden', 'true');
      $(tab).attr('aria-expanded', 'true');
      $(tab).closest('li').addClass('active');
      $(tabPanel).attr('aria-hidden', 'false');
    });
    $(document).on('click', '.js-brg', function () {});
  },
  initCourseTeaserSliders: function () {
    var that = this;
    $('.js-course-teaser-slider').each(function (index) {
      var cti = $(this).attr('data-ndx');
      appCourseTeaserSlider[index] = new Swiper(
        '.js-course-teaser-slider[data-ndx="' + cti + '"',
        {
          slidesPerView: 4,
          spaceBetween: 28,
          loop: true,
          keyboard: {
            enabled: true,
          },
          navigation: {
            nextEl: '.js-course-teaser-next[data-ndx="' + cti + '"',
            prevEl: '.js-course-teaser-prev[data-ndx="' + cti + '"',
          },
          a11y: {
            enabled: false,
          },
          on: {
            init: function () {
              // Set aria-labels dynamically from markup
              const nextButton = document.querySelector(
                `.js-course-teaser-next[data-ndx="${cti}"]`,
              );
              const prevButton = document.querySelector(
                `.js-course-teaser-prev[data-ndx="${cti}"]`,
              );

              if (nextButton) {
                nextButton.setAttribute(
                  'aria-label',
                  nextButton.getAttribute('data-aria-label'),
                );
              }
              if (prevButton) {
                prevButton.setAttribute(
                  'aria-label',
                  prevButton.getAttribute('data-aria-label'),
                );
              }
            },
          },
        },
      );
    });
  },
  addFocusWithinHandling: function () {
    const tabsBoxes = document.querySelectorAll('.teaser-tabs-wrapper');
    document.addEventListener('click', function (event) {
      let isClickInside = false;

      tabsBoxes.forEach(box => {
        if (box.contains(event.target)) {
          isClickInside = true;
          box.classList.add('focus-within');
        } else {
          box.classList.remove('focus-within');
        }
      });

      if (!isClickInside) {
        tabsBoxes.forEach(box => {
          box.classList.remove('focus-within');
        });
      }
    });
  },
};

export let appCourseTeaserSlider = [];
